const routers = [

  {
    path: '/application',
    name: 'Application',
    component: resolve => require(['../views/app/Application'], resolve)
  },
  {
    path: '/application/applicationNew',
    name: 'ApplicationNew',
    component: resolve => require(['../views/app/ApplicationNew'], resolve)
  },
  {
    path: '/application/applicationDesc',
    name: 'ApplicationDesc',
    component: resolve => require(['../views/app/ApplicationDesc'], resolve)
  },
  {
    path: '/application/applicationUpdate',
    name: 'ApplicationUpdate',
    component: resolve => require(['../views/app/ApplicationUpdate'], resolve)
  }
]
export default routers



// WEBPACK FOOTER //
// ./src/routers/app.js